// @noflow
import { ActiveBar, ActiveBarContainer, Container, MenuItem } from './styles.js';

import PropTypes from 'prop-types';
import * as React from 'react';

const propTypes = {
    activeIndex: PropTypes.number.isRequired,
    handleClick: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    purpose: PropTypes.string
};

const ModeSelectorSwitch = ({ activeIndex, handleClick, items, purpose }) => (
    <Container>
        {items.map((item, index) => (
            <MenuItem
                active={activeIndex === index}
                aria-label={purpose}
                itemIsFirst={index === 0}
                itemIsLast={index === items.length - 1}
                itemsTotal={items.length}
                key={`mode-switcher-${item}-${index}`}
                onClick={() => handleClick(index)}
            >
                {item}
            </MenuItem>
        ))}
        <ActiveBarContainer itemsTotal={items.length} selectedIndex={activeIndex}>
            <ActiveBar />
        </ActiveBarContainer>
    </Container>
);

ModeSelectorSwitch.propTypes = propTypes;
export default ModeSelectorSwitch;



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-switch/index.js